import apiClient from "@/services/api-client";

export const loginByPhoneApi = (data) => {
  return apiClient({
    method: "POST",
    url: `/v2/login`,
    data,
  });
};

export const otpVerifyApi = (data) => {
  return apiClient({
    method: "POST",
    url: `/v2/otp-verify`,
    data,
  });
};

export const registerByPhoneApi = (data) => {
  return apiClient({
    method: "POST",
    url: `/v2/registration`,
    data,
  });
};
